<template>
  <div>
    <DocumentPageTemplate :document="order.document">
      <template #header>
        <FilesUploader
          v-if="false"
          v-model="newFile"
          :disabled="$loading.isLoading('orderSingle') || disabled"
          :multiple="false"
          :name-folder="order.number"
          :showFiles="false"
          confirmMsg
          main-folder="Приказы"
          @change="() => orderUpdateDocument()" />
      </template>
      <template #info>
        <Skeleton v-if="$loading.isLoading('orderSingle')" />
        <div v-else>
          <div v-if="acknowledgmentAccess" class="mb-3">
            <v-btn
              v-if="isAcknowledgmentAgreed"
              color="success"
              style="cursor: default; pointer-events: none; width: 100%">
              <v-icon class="mr-1">
                {{ 'mdi-check' }}
              </v-icon>
              <span>Ознайомлений</span>
            </v-btn>
            <v-btn
              v-else
              class="text-white w-100"
              color="orange"
              :loading="$loading.isLoading('acknowledgmentAgree')"
              @click="acknowledgmentAgree">
              <v-icon class="mr-1">
                {{ 'mdi-eye-check-outline' }}
              </v-icon>
              <span>Ознайомитись</span>
            </v-btn>
          </div>
          <InfoFields :fields="fields" class="mb-4"></InfoFields>
          <SimpleExpansionPanel class="mb-2" label="Пов'язані накази">
            <related-orders :order="order"></related-orders>
          </SimpleExpansionPanel>
          <SimpleExpansionPanel class="mb-2" label="Коментарі">
            <Comments :disabled="!order.isActive" />
          </SimpleExpansionPanel>
          <SimpleExpansionPanel class="mb-2" label="Примітки">
            <Notes :disabled="!order.isActive" />
          </SimpleExpansionPanel>

          <v-btn
            class="mt-3 link"
            variant="text"
            @click="showFamiliarizationUsers">
            <v-icon class="mr-1">{{ 'mdi-eye-outline' }}</v-icon>
            <span>Учасники ознайомлення</span>
          </v-btn>
        </div>
      </template>
    </DocumentPageTemplate>
  </div>
</template>

<script>
import DocumentPageTemplate from '@/components/document-page-template/Index.vue'
import Skeleton from '@/components/Skeleton.vue'
import InfoFields from '@/components/InfoFields.vue'
import Comments from '@/components/comments/v2/Comments.vue'
import Notes from '@/components/notes/Notes.vue'
import { useOrder } from './order'
import { computed } from 'vue'
import { navigateToItem } from '@/utils/helpers.js'
import { openDialog } from '@/dialog/index.ts'
import SimpleExpansionPanel from '@/components/expansion-panel/SimpleExpansionPanel.vue'
import RelatedOrders from './related-orders/RelatedOrders.vue'
import { useAcknowledgment } from '@/components/acknowledgment'

export default {
  name: 'DocumentLayout',
  components: {
    DocumentPageTemplate,
    Skeleton,
    InfoFields,
    Comments,
    Notes,
    SimpleExpansionPanel,
    RelatedOrders,
  },
  setup() {
    const { order, disabled, newFile, orderUpdateDocument } = useOrder()
    const {
      isAcknowledgmentAgreed,
      acknowledgmentAccess,
      acknowledgmentAgree,
    } = useAcknowledgment()

    const fields = computed(() => {
      return [
        {
          label: 'Номер',
          value: order.number,
        },
        {
          label: 'Дата',
          value: order.date,
        },
        {
          label: 'Назва',
          value: order.name,
        },
      ]
    })

    const showFamiliarizationUsers = () => {
      openDialog({
        name: 'FamiliarizationUsers',
        dialogData: order.$object,
        params: {
          hideActionButtons: true,
        },
      })
    }

    const connectionOrders = computed(() => {
      return [order.actual_order, ...(order.related || [])].filter(Boolean)
    })

    return {
      order,
      disabled,
      fields,
      newFile,
      orderUpdateDocument,
      showFamiliarizationUsers,
      connectionOrders,
      navigateToItem,
      isAcknowledgmentAgreed,
      acknowledgmentAccess,
      acknowledgmentAgree,
    }
  },
}
</script>
